<template>
    <div class="container-fluid topbar">
        <div class="row w-100">
            <div class="col-lg-6 col-md-8 col-6 d-flex justify-content-lg-center">
                <img src="@/Content/images/topBars/logo.svg" class="img-fluid" style="max-height: 80px;" />
            </div>
            <div class="col-lg-6 col-md-4 col-6 d-flex justify-content-end">
                <div class="row mx-auto my-auto text-center" :class="isMobile">
                    <!-- <button class="btn btn-lg btn-topbar">
                        <p class="text-button mb-0">Download the catalog</p>
                    </button> -->

                    <div v-if="loadButtons() == 9" class="selectWrapper text-center" :class="widthResponsive">
                        <select v-model="resortID" class="selectBox text-center text-button" data-width="100%" @change="openURL(resortID)">
                            <template v-for="(c, index) in resorts" :key="index">
                                <option :value="c.pdf">
                                    <p v-if="c.id==null" class="text-button mb-0">Download the catalog</p>
                                    <p  class="text-button">{{ c.label }}</p>
                                    
                                </option>
                            </template>
                        </select>
                    </div>
                    <p v-else class="soon-text">Sept - 2025 Coming Soon</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            resortID: 'https://www.taferresorts.com/signature-events/made-in-mexico',
            resorts: [
                { id: null, pdf:'https://www.taferresorts.com/signature-events/made-in-mexico', label: '' },
                { id: 1,pdf:'https://www.taferresorts.com/cms/resources/calendario-hecho-en-mexico-mspv.pdf', label: 'Hotel Mousai' },
                { id: 2,pdf:'https://www.taferresorts.com/cms/resources/calendario-hecho-en-mexico-gbpv.pdf', label: 'Garza Blanca' }
            ],
        };
    },
    methods: {
        loadButtons(){
            const month = new Date().getMonth() + 1;
            return month;

        },
        openURL(URL) {
            window.open(URL, '_blank');
        }
    },
    computed: {
        isMobile() {
            return window.screen.width <= 768 ? 'w-100':'w-50';
        },
    },
    mounted() {
        this.loadButtons();
    }
};
</script>

<style scoped>
.topbar {
    width: 100% !important;
    max-height: 100px;
    background-image: url('@/Content/images/topBars/bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.btn-topbar{
    background-color: #bc0079!important;
    border-radius: 2rem;
}

.text-button {
    color: white;
    /* font-size: 10px; */
    font-size: clamp(0.75rem, 1vw + 0.5rem, 1.125rem);
    line-height: 1.2;
    word-break: break-all;

}
.select-concierge{
    opacity: 1;
    background: var(--vip-gold) 0% 0% no-repeat padding-box;
    border-radius: 2rem;
    line-height: 2;
    padding-top: 0.75rem;
    /* padding-left: 2rem;
    padding-right: 2rem; */
    padding-bottom: 0.75rem;
}
.select-concierge option{
    background: white!important;
}
.selectWrapper{
  border-radius:36px;
  display:inline-block;
  overflow:hidden;
  background:#bc0079!important;
  border:1px solid #bc0079!important;
  padding-top: 0.75rem;
  /* padding-left: 2rem;
  padding-right: 2rem; */
  padding-bottom: 0.75rem;
}
.selectBox{
  width:100%;
  height:auto;
  border:0px;
  outline:none;
  background: #bc0079!important;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: visible;
}
.optionText{
    font-family: var(--unnamed-font-family-arpona);
    font-weight: 500;
    font-size: clamp(.688rem,2vw + .25rem,1rem);
    /* text-align: center; */
    color: white!important;
}
.selectBox option{
    background: #bc0079 !important;
    color: #fff !important;

}
.soon-text {
    font-family: var(--unnamed-font-family-arpona);
    font-weight: 200;
    font-size: clamp(1rem, 1vw + 1rem, 1.5rem);
    /* text-align: center; */
    color: white!important;
}
</style>